module.exports = {
  COMPLIANCE: 'COMPLIANCE',
  DESPATCH: 'DESPATCH',
  EDI_MESSAGE: 'EDI_MESSAGE',
  RECEPTACLE: 'RECEPTACLE',
  IPC_EQUIPMENT_POOLS: 'IPC_EQUIPMENT_POOLS',
  PREDES: 'PREDES',
  CONSIGNMENT: 'CONSIGNMENT',
  MRD: 'MRD',
  CARRIER: 'CARRIER',
  HANDLER: 'HANDLER',
  EDI_EXCHANGE_OVERVIEW: 'EDI_EXCHANGE_OVERVIEW',
  EDI_EXCHANGE: 'EDI_EXCHANGE',
  CARDIT: 'CARDIT',
  PAPER_FREE: 'PAPER_FREE',
  USER_MONITORING: 'USER_MONITORING',
  ITEM: 'ITEM',
};
